import { AuthContextProps } from 'react-oidc-context'

import { getGovConfig } from 'contexts/ClientType'

import config from '../config/oidc'
import { resetTracking } from 'tracking/index'

export const Logout = (auth: AuthContextProps, isGov: boolean) => {
  if (!auth.isAuthenticated) {
    window.location.replace('/')
    return
  }

  // choose the right OIDC config
  const cfg = isGov ? getGovConfig() : config.config

  const extraQueryParams = {
    client_id: cfg?.client_id || '',
    logout_uri: window.location.origin + '/', // Cognito logout expects *logout_uri*
  }

  // Clear analytics identity so the next user on this device
  // does not inherit/merge tracking context.
  try {
    resetTracking()
  } catch {}

  auth.signoutRedirect({ extraQueryParams })
}
